<template>
    <div class="bg-white overflow-hidden shadow rounded-lg m-auto w-3/5 one-page">
        <div class="w-100 cover-style-1-image" v-if="coverImage" :style="'background-image: '+coverImage+';background-color:'+color">
        </div>
        <div class="w-100 cover-style-1-image text-center" v-else :style="';background-color:'+color+' !important'">
            <i class="fa fa-picture-o" aria-hidden="true" style="font-size: 10rem;margin-top: 8rem;color:white;"></i>
            <span style="font-size:3rem;display: block;color: white;">Please select an image</span>
        </div>
        <div class="w-100 pt-5 mt-4" id="bottom-section">
            <div class="row pl-5 pr-5">
                <div class="col-md-6">
                    <h3 :style="(section.project.name.length < 49)? 'font-size:30px;':'font-size:26px;'">{{section.project.name}}</h3>

                    <h6 class="mb-1 mt-5" style="font-weight:normal !important;text-transform: uppercase">{{team.name}}</h6>
                    <span style="font-weight:normal !important;text-transform: uppercase">By: {{proposal.created_by.name}}</span>
                </div>
                <div class="col-md-6">
                    <div v-if="coverLogo" class="cover-style-1-team-logo float-right" :style="'background-image: url('+coverLogo+');'">
                    </div>
                    <div v-else class="cover-style-1-team-logo float-right" :style="'background-image: url('+team.photo_url+');'">
                    </div>
                </div>
            </div>
            <div class="text-center text-uppercase pt-5 mt-4" style="font-size: 13px;">
                Prepared for: {{contactName}}
            </div>
        </div>
    </div>

</template>
<script>
export default {
    props: ['section', 'team', 'proposal', 'selectedResourceFile', 'coverLogo'],
    components: {},
    data() {
        return {
            coverImage:(this.selectedResourceFile)? "url('"+this.selectedResourceFile+"')":(this.proposal.selected_resource_file)? "url('"+this.proposal.selected_resource_file.url+"')":"",
            companyName: (this.proposal.contact_company_name)? this.proposal.contact_company_name:"",
            contactName: (this.proposal.contact_person_info)? this.proposal.contact_person_info.name:"",
            color: this.proposal.color,
        }

    },
    mounted() {
        Bus.$on('selectCoverImage', data => {
            if(data == ''){
                this.coverImage = "";
            }else if(data !== null && data !== undefined){
                this.coverImage = "url('"+data+"')";
                this.$parent.coverPageImageUrl = data;

            }
        });

        Bus.$on('color', data => {
            this.color = data;
        });
    },
    created() {

    },
    methods: {

    }
}
</script>
<style scoped>
p {
    margin-top: 0;
    margin-bottom: 0;
}

.cover-style-1-image{
    height: 55%;
    min-height: 35rem;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent !important;
}

.cover-style-1-team-logo{
    width: 220px;
    height: 120px;
    background-size: contain;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: center;
}
@media print{
    #bottom-section{
        /*zoom:1.5;*/
        transform: scale(1.7);
        -moz-transform: scale(1.7);
        -ms-transform: scale(1.7);
        -webkit-transform: scale(1.7);
        width: 55% !important;
        margin-top: 90px;
        margin: 0 auto;
        position:absolute;
        top: 60%;
        left: 0;
        right: 0;
    }
    img{
        display:none;
    }
    * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
    }
    br{
        display:block !important;
    }
}

</style>
